import React from "react";
import { AnalysisFailIcon, AnalysisPassIcon, AnalysisWarnIcon, InactiveEntitlementIcon, } from "../../icons";
const RiskStatusIcon = ({ status, size, disabled, }) => {
    if (disabled)
        return React.createElement(InactiveEntitlementIcon, { size: size, color: "disabled" });
    if (status === "fail")
        return React.createElement(AnalysisFailIcon, { size: size, color: "analysis-fail" });
    if (status === "warning")
        return React.createElement(AnalysisWarnIcon, { size: size, color: "analysis-warn" });
    return React.createElement(AnalysisPassIcon, { size: size, color: "analysis-pass" });
};
export default RiskStatusIcon;
//# sourceMappingURL=RiskStatusIcon.js.map